const THEME_COLORS = {
    primary: '#D25525',
    logo: '#e27a3f',
    primaryHover: '#af4721',
    secondary: '#A7ADAF',
    backgroundDecorator: '#F4F5F4',
    subdued: '#4E5152',
}

export { THEME_COLORS }